export const headersData = [
  "Order ID",
  "Status",
  "Customer name",
  // "Stack Status",
  // "EE Share",
];

export const headersData3 = [
  "Order ID",
  "Status",
  "Food Outlet",
  "Customer",
  "Driver",
  "EE share",
  "Delivery charge",
  "Order arrived",
  "Delivered at",
  // "Payment mode",
];

export const paymentsHeader = [
  "Order ID",
  "Status",
  "Food Outlet",
  "Customer",
  "Driver",
  "Driver's earning",
  "EE share",
  "Delivery charge",
  "Items",
  "Order Time",
  "Delivery Time",
];

export const analyticsHeadersData = [
  "Sr No.",
  "Order ID",
  "Outlet's name",
  "Order Status",
  "Driver's name",
  // "Driver's phone no.",
  // "Stack",
  // "EE Share",
];

export const analyticsDummyData = [
  {
    // id: 1,
    col1: "01",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "02",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "03",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "04",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "05",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "06",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
  {
    // id: 1,
    col1: "07",
    col2: "Task ID1",
    col3: "Assigned",
    col4: "Cash on Delivery",
    col5: "James Spenz",
    col6: "£05",
    button: "Order Details",
  },
];

export const outletsData = [
  {
    id: 1,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 2,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 3, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 4,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 5, name: "Palm & Pine", image: "/assets/user.png", status: "Active" },
  {
    id: 6,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 7,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 8, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 9,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  {
    id: 10,
    name: "Palm & Pine",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 11,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 12,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 13, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 14,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  {
    id: 15,
    name: "Palm & Pine",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 16,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 17,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 18, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 19,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  {
    id: 20,
    name: "Palm & Pine",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 21,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 22,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 23, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 24,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  {
    id: 25,
    name: "Palm & Pine",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 26,
    name: "Heritage Grill",
    image: "/assets/user.png",
    status: "Active",
  },
  {
    id: 27,
    name: "Urban Pipe",
    image: "/assets/user.png",
    status: "Not Active",
  },
  { id: 28, name: "Fresh Bites", image: "/assets/user.png", status: "Active" },
  {
    id: 29,
    name: "Foraged Fare",
    image: "/assets/user.png",
    status: "Not Active",
  },
  {
    id: 30,
    name: "Michael Scott",
    image: "/assets/user.png",
    status: "Active",
  },
];

export const deliveryHistoryHeader = [
  "Order ID",
  "Status",
  "Driver's earning",
  "Order arrived",
  "Delivered at",
];

export const deliveryHistoryHeader2 = [
  "Order ID",
  "Customer name",
  "Status",
  "Food Outlet",
  "Order arrived",
  "Delivered at",
  "Driver's earning",
  "EE share",
  "Items",
];

export const hubspotHeadersData = ["Sr No.", "Hubspot ID", "Order count"];
